export default __webpack_public_path__ + "072991b4f2e7b5a3053b849f972f4082.svg";